import { createStyles, makeUiStyles, Theme } from '../styles/styles';
import { StylesIndexInjections } from 'common-react';
import { DialogSize } from './tools/Dialog.model';

type DialogStyleProps = { size: DialogSize; hasScroll?: boolean };

export default makeUiStyles((theme: Theme) => createStyles({
  root: {
    '& .MuiPaper-root': {
      background: theme.color.greys[0],
      boxShadow: 'none',
      position: 'relative',
      maxWidth: ({ size }: DialogStyleProps) => size,
      width: '100%',
      borderRadius: 16,
      [theme.breakpoints.down('sm')]: {
        margin: 0,
      },
    },
    '& .MuiDialog-paperScrollPaper': {
      maxHeight: 'calc(100vh - 232px)',
      display: 'flex',
      flexDirection: 'column',
      '@media (max-height: 600px) and (orientation: landscape)': {
        maxHeight: 'calc(100vh - 32px)',
      },
    },
    '& .MuiDialogContent-root': {
      padding: 0,
      flex: 1,
      minHeight: 0,
      scrollbarWidth: 'thin',
      scrollbarColor: `${theme.color.greys[80]} transparent`,
    },
    '& .MuiDialog-paper': {
      margin: 0,
    },
    '& .MuiDialogActions-root': {
      display: 'block',
      margin: '0 28px',
      padding: 0,
    },

  },
  paperInner: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    minHeight: 0,
    padding: ({ hasScroll }: DialogStyleProps) =>
      hasScroll ? '73px 12px 40px' : '40px 12px',
  },
  dialogContentWrapper: {
    padding: '0 28px',
    boxSizing: 'border-box',
  },
  topBorder: {
    flexShrink: 0,
    height: 1,
    margin: '0 28px',
    backgroundColor: theme.color.greys[15],
  },
  footer: {
    padding: '24px 0 0',
    borderTop: `1px solid ${theme.color.greys[0]}`,
  },
  footerWithBorder: {
    borderTopColor: theme.color.greys[15],
  },
}), { name: 'Dialog', index: StylesIndexInjections.UI_MOLECULES });
